import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

export default function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        subject: '',
        budget: '',
        timeline: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        // ===== CONFIGURATION EMAILJS =====
        const serviceId = 'service_9dt336g';
        const templateId = 'template_ocisgad';
        const publicKey = '8gCYudCjsUMxstuJl';
        // ====================================

        const templateParams = {
            to_email: 'applicodetech23@gmail.com, contact@applicodetech.com', // 👈 AJOUTÉ ICI
            name: formData.name,
            email: formData.email,
            phone: formData.phone || 'Non renseigné',
            company: formData.company || 'Non renseigné',
            subject: formData.subject || 'Non spécifié',
            budget: formData.budget || 'Non spécifié',
            timeline: formData.timeline || 'Non spécifié',
            message: formData.message,
            time: new Date().toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }),
            year: new Date().getFullYear()
        };

        try {
            console.log('📤 Envoi du message...', templateParams);

            const response = await emailjs.send(
                serviceId,
                templateId,
                templateParams,
                publicKey
            );

            console.log('✅ Email envoyé avec succès!', response);
            setSubmitted(true);
            setFormData({
                name: '',
                email: '',
                phone: '',
                company: '',
                subject: '',
                budget: '',
                timeline: '',
                message: ''
            });

            setTimeout(() => setSubmitted(false), 5000);
        } catch (err) {
            console.error('❌ Erreur lors de l\'envoi:', err);
            setError(`Erreur: ${err.text || 'Veuillez réessayer ou nous contacter directement.'}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-page">
            <div className="container" style={{ paddingTop: '120px', minHeight: '100vh', paddingBottom: '4rem' }}>
                <div className="section-header">
                    <h1 style={{ fontSize: '3rem', marginBottom: '2rem', color: '#fff' }}>Contactez-nous</h1>
                    <p style={{ fontSize: '1.2rem', color: '#9ca3af', maxWidth: '600px', margin: '0 auto' }}>
                        Discutons de votre projet et voyons comment nous pouvons vous aider
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', marginTop: '3rem' }}>
                    {/* Formulaire */}
                    <div>
                        <h2 style={{ color: '#fff', marginBottom: '2rem', fontSize: '1.5rem' }}>Envoyez-nous un Message</h2>
                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                            {error && (
                                <div style={{
                                    background: 'rgba(255, 0, 0, 0.1)',
                                    border: '1px solid #ff4444',
                                    color: '#ff4444',
                                    padding: '1rem',
                                    borderRadius: '6px',
                                    textAlign: 'center'
                                }}>
                                    {error}
                                </div>
                            )}

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#fff', fontWeight: '500' }}>
                                    Nom Complet *
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '0.875rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(97, 218, 251, 0.2)',
                                        borderRadius: '6px',
                                        color: '#fff',
                                        fontFamily: 'inherit'
                                    }}
                                    placeholder="Votre nom"
                                />
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#fff', fontWeight: '500' }}>
                                    Email *
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '0.875rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(97, 218, 251, 0.2)',
                                        borderRadius: '6px',
                                        color: '#fff',
                                        fontFamily: 'inherit'
                                    }}
                                    placeholder="votre@email.com"
                                />
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#fff', fontWeight: '500' }}>
                                    Téléphone
                                </label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '0.875rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(97, 218, 251, 0.2)',
                                        borderRadius: '6px',
                                        color: '#fff',
                                        fontFamily: 'inherit'
                                    }}
                                    placeholder="+221 76 XXX XX XX"
                                />
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#fff', fontWeight: '500' }}>
                                    Entreprise
                                </label>
                                <input
                                    type="text"
                                    name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '0.875rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(97, 218, 251, 0.2)',
                                        borderRadius: '6px',
                                        color: '#fff',
                                        fontFamily: 'inherit'
                                    }}
                                    placeholder="Nom de votre entreprise"
                                />
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#fff', fontWeight: '500' }}>
                                    Sujet du Projet
                                </label>
                                <select
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '0.875rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(97, 218, 251, 0.2)',
                                        borderRadius: '6px',
                                        color: '#fff',
                                        fontFamily: 'inherit'
                                    }}
                                >
                                    <option value="">Sélectionnez un sujet</option>
                                    <option value="Développement Web">Développement Web</option>
                                    <option value="Application Mobile">Application Mobile</option>
                                    <option value="Solution Cloud">Solution Cloud</option>
                                    <option value="Cybersécurité">Cybersécurité</option>
                                    <option value="Intelligence Artificielle">Intelligence Artificielle</option>
                                    <option value="DevOps & CI/CD">DevOps & CI/CD</option>
                                    <option value="Consultation">Consultation</option>
                                    <option value="Autre">Autre</option>
                                </select>
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#fff', fontWeight: '500' }}>
                                    Budget Estimé
                                </label>
                                <select
                                    name="budget"
                                    value={formData.budget}
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '0.875rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(97, 218, 251, 0.2)',
                                        borderRadius: '6px',
                                        color: '#fff',
                                        fontFamily: 'inherit'
                                    }}
                                >
                                    <option value="">Sélectionnez un budget</option>
                                    <option value="Moins de 50 000 CFA">Moins de 50 000 CFA</option>
                                    <option value="50 000 - 100 000 CFA">50 000 - 100 000 CFA</option>
                                    <option value="100 000 - 500 000 CFA">100 000 - 500 000 CFA</option>
                                    <option value="500 000 - 1 000 000 CFA">500 000 - 1 000 000 CFA</option>
                                    <option value="Plus de 1 000 000 CFA">Plus de 1 000 000 CFA</option>
                                </select>
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#fff', fontWeight: '500' }}>
                                    Délai Souhaité
                                </label>
                                <select
                                    name="timeline"
                                    value={formData.timeline}
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '0.875rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(97, 218, 251, 0.2)',
                                        borderRadius: '6px',
                                        color: '#fff',
                                        fontFamily: 'inherit'
                                    }}
                                >
                                    <option value="">Sélectionnez un délai</option>
                                    <option value="Urgent (1-2 semaines)">Urgent (1-2 semaines)</option>
                                    <option value="Court terme (1-3 mois)">Court terme (1-3 mois)</option>
                                    <option value="Moyen terme (3-6 mois)">Moyen terme (3-6 mois)</option>
                                    <option value="Long terme (6+ mois)">Long terme (6+ mois)</option>
                                </select>
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '0.5rem', color: '#fff', fontWeight: '500' }}>
                                    Message Détaillé *
                                </label>
                                <textarea
                                    name="message"
                                    rows="5"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '0.875rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(97, 218, 251, 0.2)',
                                        borderRadius: '6px',
                                        color: '#fff',
                                        fontFamily: 'inherit',
                                        resize: 'vertical'
                                    }}
                                    placeholder="Décrivez votre projet, vos objectifs et vos défis..."
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    background: loading ? '#666' : '#ff7e5f',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '0.875rem 1.75rem',
                                    borderRadius: '6px',
                                    fontWeight: '600',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    fontSize: '0.95rem',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    if (!loading) {
                                        e.target.style.background = '#ff6a48';
                                        e.target.style.transform = 'translateY(-2px)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!loading) {
                                        e.target.style.background = '#ff7e5f';
                                        e.target.style.transform = 'translateY(0)';
                                    }
                                }}
                            >
                                {loading ? 'Envoi en cours...' : 'Envoyer le Message'}
                            </button>

                            {submitted && (
                                <div style={{
                                    background: 'rgba(97, 218, 251, 0.1)',
                                    border: '1px solid #61DAFB',
                                    color: '#61DAFB',
                                    padding: '1rem',
                                    borderRadius: '6px',
                                    textAlign: 'center',
                                    animation: 'slideUp 0.3s ease-out'
                                }}>
                                    ✓ Message envoyé avec succès ! Nous vous répondrons dans les 24 heures.
                                </div>
                            )}
                        </form>
                    </div>

                    {/* Informations */}
                    <div>
                        <h2 style={{ color: '#fff', marginBottom: '2rem', fontSize: '1.5rem' }}>Nos Coordonnées</h2>

                        <div style={{
                            background: 'rgba(255, 126, 95, 0.05)',
                            border: '1px solid rgba(255, 126, 95, 0.2)',
                            padding: '2rem',
                            borderRadius: '10px',
                            marginBottom: '2rem'
                        }}>
                            <div style={{ marginBottom: '2rem' }}>
                                <h4 style={{ color: '#ff7e5f', marginBottom: '0.5rem', fontSize: '1.1rem' }}>📧 Email</h4>
                                <a href="mailto:applicodetech23@gmail.com" style={{ color: '#9ca3af', textDecoration: 'none', display: 'block' }}>
                                    applicodetech23@gmail.com
                                </a>
                                <a href="mailto:contact@applicodetech.com" style={{ color: '#9ca3af', textDecoration: 'none', display: 'block' }}>
                                    contact@applicodetech.com
                                </a>
                            </div>

                            <div style={{ marginBottom: '2rem' }}>
                                <h4 style={{ color: '#ff7e5f', marginBottom: '0.5rem', fontSize: '1.1rem' }}>📱 Téléphone</h4>
                                <a href="tel:+221766091932" style={{ color: '#9ca3af', textDecoration: 'none', display: 'block' }}>
                                    +221 76 609 19 32 (Principal)
                                </a>
                                <a href="tel:+221711589276" style={{ color: '#9ca3af', textDecoration: 'none', display: 'block' }}>
                                    +221 71 158 92 76 (Support)
                                </a>
                            </div>

                            <div style={{ marginBottom: '2rem' }}>
                                <h4 style={{ color: '#ff7e5f', marginBottom: '0.5rem', fontSize: '1.1rem' }}>📍 Localisation</h4>
                                <p style={{ color: '#9ca3af', marginBottom: '0.5rem' }}>
                                    Saint-Louis, Sénégal
                                </p>
                            </div>
                        </div>

                        <div style={{
                            background: 'rgba(97, 218, 251, 0.05)',
                            border: '1px solid rgba(97, 218, 251, 0.2)',
                            padding: '2rem',
                            borderRadius: '10px',
                            marginBottom: '2rem'
                        }}>
                            <h4 style={{ color: '#61DAFB', marginBottom: '1rem', fontSize: '1.1rem' }}>⚡ Réponse Rapide</h4>
                            <p style={{ color: '#9ca3af', marginBottom: '1rem' }}>
                                Nous répondons généralement à vos messages dans les <strong>24 heures</strong>.
                            </p>
                            <p style={{ color: '#9ca3af', fontSize: '0.9rem' }}>
                                Pour les demandes urgentes, appelez-nous directement au numéro principal ci-dessus.
                            </p>
                        </div>

                        <div style={{
                            background: 'rgba(255, 126, 95, 0.05)',
                            border: '1px solid rgba(255, 126, 95, 0.2)',
                            padding: '2rem',
                            borderRadius: '10px'
                        }}>
                            <h4 style={{ color: '#ff7e5f', marginBottom: '1rem', fontSize: '1.1rem' }}>🚀 Prochaines Étapes</h4>
                            <ol style={{ color: '#9ca3af', paddingLeft: '1.5rem' }}>
                                <li style={{ marginBottom: '0.75rem' }}>Vous nous envoyez vos détails via le formulaire</li>
                                <li style={{ marginBottom: '0.75rem' }}>Nous organisons une consultation gratuite</li>
                                <li style={{ marginBottom: '0.75rem' }}>Nous créons un devis personnalisé</li>
                                <li>Nous commençons le développement du projet</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </div>
    );
}